const BaseGUrl = "https://api.alikar.ir";

 
const GURL = `${BaseGUrl}/api`;

export { GURL, BaseGUrl  };
